import React from "react";
import { GLOBAL_COPYRIGHT_NOTICE } from "../../src/privacyAgreement";

export default function GlobalCopyrightNotice({ compact = false }) {
  return (
    <div
      style={{
        borderTop: "1px solid #dbe3f0",
        background: "#f8fbff",
        color: "#1e3a5f",
        fontSize: compact ? "11px" : "12px",
        lineHeight: 1.4,
        padding: compact ? "8px 12px" : "10px 14px",
        textAlign: "center"
      }}
    >
      {GLOBAL_COPYRIGHT_NOTICE}
    </div>
  );
}
